import { useState } from "react";
import { Button } from "reactstrap";
import { View } from "../../../types/PageInterfaces";
import QRScannerDrawer from "./QRScannerDrawer";

interface Props {
  view?: View;
  parentRecord?: Record<string, any>;
}

export default function QRScannerButton({ view, parentRecord }: Props) {
  const [open, setOpen] = useState(false);

  if (!view || !view?.QrCodeConfig) return null;

  return (
    <>
      <div
        style={{ position: "fixed", bottom: 0, right: 0, zIndex: 999 }}
        className="btn-oauth w-100 p-3 d-flex justify-content-center bg-white border border-ultralight border-top"
      >
        <Button
          color="primary"
          onClick={() => setOpen(true)}
          className="px-3 d-flex align-items-center pt-2 pb-2"
        >
          <i
            className="mdi mdi-camera pr-2 mt-1"
            style={{ fontSize: 18, lineHeight: 1 }}
          />
          Scan QR
        </Button>
      </div>
      {view?.QrCodeConfig && (
        <QRScannerDrawer
          open={open}
          onClose={() => setOpen(false)}
          moduleAPIName={view.ModuleAPIName}
          searchField={view.QrCodeConfig.SearchField}
          fieldsToUpdate={view.QrCodeConfig.FieldsToUpdate}
          recordRequirements={view.QrCodeConfig.RecordConditions}
          parentRecord={parentRecord}
        />
      )}
    </>
  );
}
